import PropTypes from 'prop-types';
import React from 'react';

import * as PaymentsConstants from '../../constants';
import UpgradeCard from '../UpgradeCard/UpgradeCard';

const TIERS = [
  PaymentsConstants.tiers.AD_SUPPORTED,
  PaymentsConstants.tiers.PANDORA_PLUS,
  PaymentsConstants.tiers.PANDORA_PREMIUM,
];

export default class AnonUpgradeCards extends React.Component {
  static propTypes = {
    isOldAndroid: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
    isLanding: PropTypes.bool,
  };

  render() {
    return TIERS.map(tier => {
      const props = {
        key: tier,
        tier,
        discountType: PaymentsConstants.discountTypes.NONE,
        isAnon: true,
        isOldAndroid: this.props.isOldAndroid,
        isMobile: this.props.isMobileDevice,
        isLanding: this.props.isLanding,
      };

      return <UpgradeCard key={0} {...props} />;
    });
  }
}
